import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../default-settings-service.service';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-inventory-item-small',
  templateUrl: './inventory-item-small.component.html',
  styles: []
})
export class InventoryItemSmallComponent extends ExcTranslation implements OnInit {
  @Input('data') data;
  @Input('isReview') isReview = false;

  dateNow = Date.now();

  constructor(private excDss: DefaultSettingsService,
              public datePipe: DatePipe) {
    super();
    this.dateNow = Date.now();
  }
  getInventoryLocationClass() {
    if (this.data.LocationIsPrimary) {
      return 'default';
    }
    if (this.excDss.MandantSettings.LocationsEnabled === true) {
      if (this.data.InventoryLocationApproved) {
        return 'success';
      } else {
        return 'danger';
      }
    } else {
      return 'warning';
    }
  }
  getInventoryLocationSubClass(r) {
    if (r.LocationIsPrimary) {
      return 'default';
    }
    if (this.excDss.MandantSettings.LocationsEnabled === true) {
      if (r.InventoryLocationApproved) {
        return 'success';
      } else {
        return 'danger';
      }
    } else {
      return 'warning';
    }
  }
  getAvatarClass() {
    if (this.data.InventoryCode === null) {
      return 'th-secondary fa-question';
    }
    if (this.data.InventoryOk === true) {
      return 'th-success fa-check';
    } else {
      return 'th-danger fa-times';
    }
  }
  getPartialResultTooltip() {
    let msg = '';
    for (const r of this.data.Results) {
        msg += this.getGlobal('AuditType_' + r.AuditType);
        if (r.DocumentCode !== '') {
          msg += '\r\n  ' + r.DocumentCode + ' - ' + r.DocumentCodeDescription;
        }
        if (r.InventoryCode !== '') {
          msg += '\r\n  ' + r.InventoryCode + ' - ' + r.InventoryCodeDescription;
        }
        msg +=  '\r\n\r\n';
    }
    return msg;
  }
  getAvatarTip() {
    if (this.data.InventoryCode === null) {
      return this.getRessource('Unchecked');
    }
    if (this.data.InventoryOk === true) {
      return this.getRessource('CheckOk');
    }
    return this.getRessource('CheckNok');
  }
  getAvatarReviewClass() {
    if (this.data.InventoryIsCleared === true) {
      if (this.data.InventoryClearedCodeOk === null) {
        return 'th-secondary fa-question';
      } else {
        if (this.data.InventoryClearedCodeOk === true) {
          return 'th-success fa-check';
        } else {
          return 'th-danger fa-times';
        }
      }
    } else {
      return 'th-secondary fa-question';
    }
  }
  getAttachmentsClass(r = null) {
    if (r !== null) {
      if (r.InventoryAttachmentsAllCleared === true) {
        return r.InventoryAttachmentsAllOk === true ? 'th-success' : 'th-danger';
      }
      return 'th-secondary';
    } else {
      if (this.data.InventoryAttachmentsAllCleared === true) {
        return this.data.InventoryAttachmentsAllOk === true ? 'th-success' : 'th-danger';
      }
      return 'th-secondary';
    }
  }
  getAvatarReviewTip() {
    if (this.data.InventoryIsCleared === true) {
        return this.data.InventoryClearedCodeDescription;
    } else {
      return this.getRessource('ReviewOpen');
    }
  }
  getAttractorTip() {
    if (this.data.InventoryPresent === true) {
      return this.getRessource('Seen');
    } else {
      return this.getRessource('NotSeen');
    }
  }
  getAttractorClass() {
    if (this.data.InventoryCode === null) {
      return '';
    }
    if (this.data.InventoryPresent === true) {
      return 'ch-success fa-eye';
    } else {
      return 'ch-danger fa-eye-slash';
    }
  }

  getLocationTooltip(x) {
    const item = x || this.data;

    const loc = {
      Street: item.LocationStreet,
      Zip: item.LocationZip,
      City: item.LocationCity,
      Name: item.LocationName
    };

    if (item.LocationIsPrimary === true) {
      return this.getRessource('LocationPrimary', loc);
    }

    if (this.excDss.MandantSettings.LocationsEnabled === true) {
      if (item.InventoryLocationApproved === true) {
        return this.getRessource('LocationApproved', loc);
      } else {
        return this.getRessource('LocationNotApproved', loc);
      }
    } else {
      return this.getRessource('LocationOther', loc);
    }
  }

  getVinTip() {
    if (this.data.InventoryIsCleared === true) {
      return this.data.InventoryClearedCodeDescription;
    } else {
      return this.getGlobal('Open');
    }
  }
  getVinTextClass() {
    if (this.data.InventoryIsCleared === true) {
      if (this.data.InventoryClearedCodeOk === null) {
        return 'th-bold th-secondary';
      } else {
        if (this.data.InventoryClearedCodeOk === true) {
          return 'th-bold th-success';
        } else {
          if (this.data.InventoryClearedCodeCritical === true) {
            return 'th-bold th-danger';
          } else {
            return 'th-bold th-warning';
          }
        }
      }
    } else {
      return 'th-bold th-secondary';
    }
  }

  ngOnInit() {
  }

}
